import { Component, OnInit, ElementRef, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

/**
 * Component wrapper for DashboardTemplatesController
 */
@Component({
  selector: 'dashboard-templates-list',
  template: '<dashboard-templates-list-directive></dashboard-templates-list-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DashboardTemplatesListComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // No route params needed for list component
  }
}

/**
 * Directive for downgrading DashboardTemplatesListComponent
 */
@Component({
  selector: 'dashboard-templates-list-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DashboardTemplatesListDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('dashboardTemplatesList', elementRef, injector);
  }
}

/**
 * Component wrapper for DashboardTemplateController (form)
 */
@Component({
  selector: 'dashboard-template-form',
  template: '<dashboard-template-form-directive [id]="id"></dashboard-template-form-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DashboardTemplateFormComponent {
  @Input() id: string;
}

/**
 * Directive for downgrading DashboardTemplateFormComponent
 */
@Component({
  selector: 'dashboard-template-form-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DashboardTemplateFormDirective extends UpgradeComponent {
  @Input() id: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('dashboardTemplateForm', elementRef, injector);
  }
}

/**
 * Component wrapper for DashboardReorderController
 */
@Component({
  selector: 'dashboard-templates-reorder',
  template: '<dashboard-templates-reorder-directive></dashboard-templates-reorder-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DashboardTemplatesReorderComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // No route params needed for reorder component
  }
}

/**
 * Directive for downgrading DashboardTemplatesReorderComponent
 */
@Component({
  selector: 'dashboard-templates-reorder-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DashboardTemplatesReorderDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('dashboardTemplatesReorder', elementRef, injector);
  }
}
